import React, { Component } from 'react';
import { graphql, createFragmentContainer } from 'react-relay';
import { pick } from 'lodash';
import moment from 'moment';

import {
  StoreProvider,
  ImageUploader,
  ErrorFlash,
  Label,
} from '../../components';
import { formatDate } from '../../utils/functions';
import { createMessage } from '../../mutations';

import Field from './Field';

export class AssociatedMessageNewView extends Component {
  state = {
    title: '',
    body: '',
    backgroundImage: null,
    endDate: this.props.messageable.endDate,
    errors: null,
  };

  handleSubmit = (event) => {
    event.preventDefault();
    const { relay, lists, match } = this.props;
    const attributes = pick(this.state, [
      'title',
      'body',
      'backgroundImage',
      'endDate',
    ]);
    attributes.messageableId = match.params.messageableId;

    createMessage(relay.environment, attributes, lists.id, {
      onCompleted: this.handleCompleted,
    });
  };

  handleCompleted = (response) => {
    const { errors } = response.createMessage;
    const isFromBrand = this.props.location?.state?.isFromBrand || false;
    const brandId = this.props.location?.state?.brandId;
    const router = isFromBrand ? `/brands/${brandId}` : '/messages/tab/active';

    if (errors) {
      this.setState({ errors });
    } else {
      this.props.history.push(router);
    }
  };

  handleChange = (name, value) => {
    this.setState({ [name]: value });
  };

  handleImageUploaded = (backgroundImage) => {
    this.setState({ backgroundImage });
  };

  render() {
    const { errors } = this.state;
    const { messageableType } = this.props.match.params;
    const { title, body, backgroundImageUrl, endDate } = this.props.messageable;

    return (
      <div className="message-new">
        <form className="message-form" onSubmit={this.handleSubmit}>
          <div className="form-header">
            <h2>Add Message</h2>
            <div className="form-header-actions">
              <input
                id="saveMessage"
                className="message-new-submit"
                type="submit"
                value="Save"
              />
            </div>
          </div>
          <div className="form-fields">
            <ErrorFlash errors={errors} />
            <div className="form-group">
              <h3>General</h3>
              <div className="form-group-fields">
                <div className="form-group-column">
                  <Field
                    name="title"
                    placeholder={title}
                    errors={errors}
                    attributes={this.state}
                    onChange={this.handleChange}
                  />
                  <Field
                    name="body"
                    placeholder={body}
                    errors={errors}
                    attributes={this.state}
                    onChange={this.handleChange}
                    element="textarea"
                  />
                  <div>
                    <em>
                      This message will expire when the{' '}
                      {messageableType.replace(/-/g, ' ')} expires at{' '}
                      <strong>{formatDate(endDate)}</strong>.
                    </em>
                  </div>
                </div>
                <div className="form-group-column">
                  <div className="input image-upload">
                    <Label attr="image" text="Image" errors={errors} />
                    <div className="image-upload-hint">
                      Image should be a .png or .jpg
                    </div>
                    <ImageUploader
                      id="backgroundImage"
                      onUploaded={this.handleImageUploaded}
                      source={backgroundImageUrl}
                      type="message"
                      cover
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

const Container = createFragmentContainer(AssociatedMessageNewView, {
  messageable: graphql`
    fragment AssociatedMessageNew_messageable on Messageable {
      id
      title
      body
      backgroundImageUrl
      endDate
    }
  `,
  lists: graphql`
    fragment AssociatedMessageNew_lists on Lists {
      id
    }
  `,
});

export default class AssociatedMessageNew extends Component {
  render() {
    return (
      <StoreProvider
        container={Container}
        query={graphql`
          query AssociatedMessageNewQuery($messageableId: ID!) {
            messageable: node(id: $messageableId) {
              ...AssociatedMessageNew_messageable
            }
            lists {
              ...AssociatedMessageNew_lists
            }
          }
        `}
      />
    );
  }
}
